import { Grid, Skeleton } from "@mui/material";
import KeyValueCard from "../pricing-reports/design/KeyValueCard";

const EMPTY_VALUE = "—";

function formatMostPromotedProduct(topProduct) {
  if (topProduct == null) return EMPTY_VALUE;
  return topProduct.productName;
}

export default function FlyerReportSummaryCards({ flyerSummaryStats, isLoading }) {
  const showInitialLoadingSkeletons =
    Boolean(isLoading) && flyerSummaryStats === undefined;

  const cards = [
    {
      key: "most-promoted-product",
      label: "Most promoted product",
      value: showInitialLoadingSkeletons
        ? EMPTY_VALUE
        : formatMostPromotedProduct(flyerSummaryStats?.topProduct ?? null),
    },
    {
      key: "total-offers",
      label: "Total promotions",
      value: showInitialLoadingSkeletons
        ? EMPTY_VALUE
        : String(flyerSummaryStats?.totalOfferCount ?? 0).toLocaleString(),
    },
    {
      key: "unique-retailers",
      label: "Retailers running promotions",
      value: showInitialLoadingSkeletons
        ? EMPTY_VALUE
        : String(flyerSummaryStats?.uniqueRetailerCount ?? 0).toLocaleString(),
    },
  ];

  return (
    <Grid container className="pricing-report-print-kpi-grid">
      {cards.map((card) => (
        <Grid key={card.key} item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
          {showInitialLoadingSkeletons ? (
            <Skeleton variant="rounded" height={120} className="no-print" sx={{ width: "100%" }} />
          ) : (
            <KeyValueCard
              label={card.label}
              value={card.value}
              sx={{ width: "100%", flex: 1 }}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
}
